import React, {useEffect, useMemo} from 'react';
import {useIntl} from 'react-intl';

import globalMessages from 'brand/app/components/messages';
import {Button, DropdownSelect} from 'brandComponents';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import messages from 'brandComponents/ChangeCountry/messages';

import styles from './SelectCountryForm.module.scss';

const SelectCountryForm = ({handleSubmit, form, submitting, hasValidationErrors, values}) => {
	const intl = useIntl();
	const {managerRepository} = useGeneralProvider();
	const countries = managerRepository.getCountriesMgr().getCountries();
	const isSubmitButtonDisabled: boolean = hasValidationErrors || submitting;

	const countriesOptions = useMemo(() => {
		const countriesArray = countries.map((country) => {
			const countryMessage = {
				id: `country.${country.getCountryCode()}`,
				defaultMessage: country.getCountryCode(),
			};

			return {
				value: country.getCountryCode(),
				label: intl.formatMessage(countryMessage),
			};
		});

		return countriesArray.sort((a, b) => a.label?.localeCompare(b?.label));
	}, []);

	const selectedCountry = useMemo(() => {
		return countries.find((country) => country.getCountryCode() === values.country);
	}, [values.country]);

	const selectedCountryLanguages = useMemo(() => {
		if (selectedCountry) {

			return selectedCountry.getAvailableLanguages().map(language => ({
				value: language,
				label: intl.formatMessage(globalMessages[language]),
			}));
		}

		return [];
	}, [selectedCountry]);

	const selectedCountryCurrency = useMemo(() => {
		if (selectedCountry) {
			return selectedCountry.getCurrencyCode() + ' (' + selectedCountry.getCurrencySymbol() + ')';
		}

		return '';
	}, [selectedCountry]);

	useEffect(() => {
		const languages = selectedCountryLanguages;

		if (languages.length > 0) {
			form.change('language', languages[0].value);
		}
	}, [values.country]);

	return (
		<div className={styles['country-form']}>
			<DropdownSelect
				name="country"
				data={countriesOptions}
				label={intl.formatMessage(messages.selectCountry)}
			/>

			{selectedCountryLanguages.length > 1 && (
				<DropdownSelect
					name="language"
					data={selectedCountryLanguages}
					label={intl.formatMessage(messages.selectLanguage)}
				/>
			)}

			<div className={styles['country-form__currency']}>
				<span>{intl.formatMessage(messages.orderBilledLabel)}</span>
				<span>
					{selectedCountryCurrency}
				</span>
			</div>

			<div className={styles['country-form__submit']}>
				<Button
					variant="secondary-white"
					type="submit"
					disabled={isSubmitButtonDisabled}
					onClick={handleSubmit}
				>
					{intl.formatMessage(messages.confirmButton)}
				</Button>
			</div>
		</div>
	);
};

export default SelectCountryForm;
